import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { photoshop } from "../globals";
import { useListenFromRenderer } from "../message";

export function useCheckNewAssetsInfo() {
	const previousData = useRef<{ script: string; css: string } | null>(null);

	const { refetch } = useQuery({
		queryKey: ["repoData"],
		queryFn: () =>
			fetch("https://ps-uxp.oplux.ai/assets-info.json")
				.then((res) => res.json())
				.then(async (data) => {
					if (!data) return;
					const prev = previousData.current;
					const changed =
						!prev || prev.script !== data.script || prev.css !== data.css;
					if (changed && prev) {
						await photoshop.app.showAlert(
							"A new version of the plugin is available. Restarting to apply the update.",
						);
						location.reload();
					}
					previousData.current = data;
				}),
	});

	useListenRefetchMessage(refetch);
}

export function useListenRefetchMessage(refetch: () => void) {
	useListenFromRenderer([
		{
			key: "refetch",
			onMessage: () => {
				refetch();
			},
		},
	]);
}
